var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-list",
    { staticClass: "order-list", attrs: { "two-line": "" } },
    [
      _vm.noDataVisible
        ? _c("div", { staticClass: "text-xs-center grey--text title py-4" }, [
            _vm._v(" " + _vm._s(_vm.$t("no_data")) + " ")
          ])
        : _vm._e(),
      _vm._l(_vm.ordersTimeline, function(item, index) {
        return _c(
          "div",
          { key: index },
          [
            index !== 0 ? _c("v-divider") : _vm._e(),
            _c(
              "v-list-tile",
              {
                key: index,
                staticClass: "timeline__row",
                attrs: { avatar: "", to: "/record/" + item.order_id }
              },
              [
                _c("v-list-tile-avatar", [
                  _c("img", {
                    directives: [
                      {
                        name: "img-fallback",
                        rawName: "v-img-fallback",
                        value: "/v1/assets/images/notification-icon.png",
                        expression: "'/v1/assets/images/notification-icon.png'"
                      }
                    ],
                    attrs: { src: item.data.order_avatar }
                  })
                ]),
                _c(
                  "v-list-tile-content",
                  { attrs: { title: item.data.pathTile } },
                  [
                    _c("div", { staticClass: "body-1" }, [
                      _c("span", {
                        directives: [
                          {
                            name: "dompurify-html",
                            rawName: "v-dompurify-html",
                            value: _vm.$t(
                              "order_timeline.status_tracker." + item.type,
                              {
                                supplier_name: item.data.supplier_name,
                                order_id: item.order_id
                              }
                            ),
                            expression:
                              "\n              $t('order_timeline.status_tracker.' + item.type, {\n                supplier_name: item.data.supplier_name,\n                order_id: item.order_id\n              })\n            "
                          }
                        ]
                      })
                    ]),
                    _c(
                      "v-list-tile-sub-title",
                      [
                        _vm._v(
                          " " + _vm._s(item.data["format_" + item.type]) + " "
                        ),
                        _c("v-icon", { attrs: { small: "" } }, [
                          _vm._v("person")
                        ]),
                        _vm._v(" " + _vm._s(item.data.user_name) + " ")
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }